import { NewApplicationStepStatus } from '../../hoc/new-application/types';

import cn from './new-application.module.css';

const Step = ({
  status,
  title,
  id,
}: {
  status: NewApplicationStepStatus;
  title: string;
  id: string;
}) => (
  <a
    href={`#${id}`}
    target="_self"
    className={`${cn.step} ${
      status === NewApplicationStepStatus.COMPLETED ? cn.stepCompleted : ''
    } ${
      status === NewApplicationStepStatus.IN_PROGRESS ? cn.stepInprogress : ''
    }`}
  >
    <div className={cn.stepLine} />
    <div className={cn.stepTitle}>{title}</div>
  </a>
);

export default Step;
